interface GalleryImage {
  id: number;
  src: string;
  title: string;
  location: string;
  category: string;
  description: string;
  date: string;
  featured?: boolean;
  highlight?: string;
}

const galleryImages: GalleryImage[] = [
  {
    id: 1,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/da07f78a96743b34a9fc5f0d74e31bb6.jpeg",
    title: "Guest Lecture on Java App Development",
    location: "Sri Manakula Vinayagar Engineering College",
    category: "Higher Education",
    description: "Certificate presentation ceremony following an intensive session on building and deploying Java applications",
    date: "04.09.2025",
    featured: true
  },
  {
    id: 2,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/adfecba99a1073079e82719080da44ea.jpeg",
    title: "Embedded Systems Using Raspberry Pi",
    location: "Aadhiparasakthi Engineering College",
    category: "Embedded Systems",
    description: "An intensive program on hardware-software integration, building strong foundations in Embedded Systems using Raspberry Pi — powered by TNSkill & Siemens TANDAM initiative.",
    date: "2025",
    highlight: "TNSkill x Siemens TANSAM"
  },
  {
    id: 3,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/bd8f7e307a11023aa75a7f229f09d0eb.jpeg",
    title: "Certification Program Training",
    location: "Thankshila University, Tindivanam, Tamil Nadu",
    category: "Certification Program",
    description: "Successfully conducted an intensive Certification Program Training at Thankshila University — empowering students with industry-relevant skills and recognized credentials.",
    date: "31.10.2025",
    highlight: "Tindivanam, TN"
  },
  {
    id: 4,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/7e06f724a62bc53305b0ef7119078a71.jpeg",
    title: "Data Analytics Using Python",
    location: "Mohammad Sathek AJ Engineering College",
    category: "Data Analytics",
    description: "High-quality skill development program delivered under ICT Academy — equipping students with hands-on expertise in Data Analytics using Python inside the college's dedicated RPA lab.",
    date: "2025",
    highlight: "ICT Academy"
  },
  {
    id: 5,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/69660f65510ad7ad0a279fa8dbcb3b71.jpeg",
    title: "Data Analytics — Full Lab Session",
    location: "MRK Institute of Technology, Cuddalore",
    category: "Data Analytics",
    description: "A fully packed computer lab session delivering high-quality Data Analytics skill development under the Vetri Nichayam TN initiative — every seat taken, every student engaged.",
    date: "2025",
    highlight: "Vetri Nichayam TN"
  },
  {
    id: 6,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/5bf6a51ce388ea13303f067fed91e09b.jpeg",
    title: "AI & Data Science Program",
    location: "Mailam Engineering College, Tamil Nadu",
    category: "AI & Data Science",
    description: "Successfully delivered a high-quality AI & Data Science skill development program at the Dept. of Computer Science & Engineering under ICT Academy, TN — building future-ready tech talent.",
    date: "2025",
    highlight: "ICT Academy, TN"
  },
  {
    id: 7,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/34cd0f7a89bcb002f4fd94170421818a.jpeg",
    title: "Corporate Training Program",
    location: "ESAB India Manufacturing Pvt. Ltd., Chennai",
    category: "Corporate Training",
    description: "Successfully delivered an intensive corporate training program for ESAB India employees — upskilling manufacturing professionals with hands-on data analytics and digital tools in a live industry setting.",
    date: "2025",
    highlight: "Corporate Upskilling"
  },
  {
    id: 8,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/a736294371415dd704268277e9e6a4b7.jpeg",
    title: "Advanced Power BI Training",
    location: "ESAB India Mfg. Pvt. Ltd., Ambattur, Chennai",
    category: "Power BI",
    description: "Delivered Advanced Power BI corporate training for ESAB India employees at their Ambattur Industrial Estate facility — transforming manufacturing professionals into data-driven decision makers.",
    date: "26.09.2025",
    highlight: "Advanced Analytics"
  },
  {
    id: 9,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/35bea1de0c26b4e4d4b0d9c77e20fa6e.jpeg",
    title: "Robotics Workshop — Object Following Robot",
    location: "VKM Vidhyalaya Sr. Secondary School, Tindivanam",
    category: "School Robotics",
    description: "Successfully delivered a Robotics Workshop to a packed school auditorium — introducing young students to the exciting world of object-following robots and hands-on STEM concepts.",
    date: "2025",
    highlight: "K-12 STEM"
  },
  {
    id: 10,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/6213c6561c5632e16eabe77ae70d46b8.jpeg",
    title: "Industry Mentoring & Real-World Guidance",
    location: "Sri Manakula Vinayagar Engineering College",
    category: "Mentoring Session",
    description: "A candid, informal session bridging classroom learning with industry reality — students discussing real-world challenges and receiving one-on-one career guidance from STEMForge mentors.",
    date: "2025",
    highlight: "Beyond the Classroom"
  }
];

export default function TrainingGallery() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-100 text-emerald-700 text-sm font-semibold uppercase tracking-wider rounded-full mb-4">
            <i className="ri-camera-lens-line"></i>
            Training in Action
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            Real Sessions.
            <span className="text-emerald-600"> Real Impact.</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            A curated look at STEMForge Tech Labs workshops, guest lectures, and hands-on training moments across institutions nationwide.
          </p>
        </div>

        {/* Masonry Grid Gallery */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image) => (
            <div
              key={image.id}
              className={`group relative overflow-hidden rounded-2xl bg-white shadow-sm hover:shadow-xl transition-all duration-500 ${
                image.featured ? 'md:col-span-2 row-span-2' : ''
              }`}
            >
              {/* Image Container */}
              <div className={`relative overflow-hidden ${image.featured ? 'h-[480px]' : 'h-72'}`}>
                <img
                  src={image.src}
                  alt={image.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                />

                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300"></div>

                {/* Category Badge */}
                <div className="absolute top-4 left-4 flex flex-col gap-2">
                  <span className="px-3 py-1.5 bg-emerald-500 text-white text-xs font-semibold rounded-full uppercase tracking-wide whitespace-nowrap">
                    {image.category}
                  </span>
                  {image.highlight && (
                    <span className="px-3 py-1.5 bg-orange-500 text-white text-xs font-semibold rounded-full uppercase tracking-wide whitespace-nowrap">
                      {image.highlight}
                    </span>
                  )}
                </div>

                {/* Content Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                  {/* Date */}
                  <div className="flex items-center gap-2 text-emerald-300 text-sm mb-2">
                    <i className="ri-calendar-line"></i>
                    <span>{image.date}</span>
                  </div>

                  {/* Title */}
                  <h3 className={`font-bold text-white mb-2 ${image.featured ? 'text-2xl' : 'text-lg'}`}>
                    {image.title}
                  </h3>

                  {/* Location */}
                  <div className="flex items-center gap-2 text-gray-300 text-sm mb-3">
                    <i className="ri-map-pin-line text-emerald-400"></i>
                    <span>{image.location}</span>
                  </div>

                  {/* Description */}
                  <p className={`text-gray-300 text-sm leading-relaxed ${image.featured ? 'block' : 'hidden group-hover:block'}`}>
                    {image.description}
                  </p>
                </div>

                {/* Hover Zoom Icon */}
                <div className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-zoom-in-line text-white text-lg"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats Bar */}
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-6">
          {[
            { value: "100+", label: "Training Sessions", icon: "ri-presentation-line" },
            { value: "5,000", label: "Students Engaged", icon: "ri-user-star-line" },
            { value: "PAN India", label: "28 States Covered", icon: "ri-map-2-line" }
          ].map((stat, idx) => (
            <div key={idx} className="bg-white rounded-xl p-6 text-center shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 rounded-full bg-emerald-50 flex items-center justify-center mx-auto mb-3">
                <i className={`${stat.icon} text-2xl text-emerald-600`}></i>
              </div>
              <div className="text-2xl font-bold text-gray-900 mb-1">{stat.value}</div>
              <div className="text-gray-600 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}